import { GroupStats } from '@front-app/services/GroupsApi/GroupModel';
import { getGroupStats } from '@front-app/services/GroupsApi/GroupsApi';
import { reactive, Ref, toRefs } from '@vue/composition-api';

export interface GroupStatsStore {
	getStats(groupIds: string[]): Promise<void>;
	stats: Ref<Record<string, GroupStats>>;
}

export const getGroupStatsStore = (): GroupStatsStore => {
	const state = reactive({
		stats: {} as Record<string, GroupStats>,
	});
	const getStats = async (groupIds: string[]) => {
		const stats = await getGroupStats(groupIds.filter((id) => !state.stats[id]));
		state.stats = stats
			.reduce((acc, curr) => {
				acc[curr.id] = curr;
				return acc;
			}, { ...state.stats });
	};
	return {
		getStats,
		...toRefs(state),
	};
};
